<template>
  <div>
    <search-bar
      @search="onSearch"
      name="dd_prodcode,pr_detail,pr_orispeccode"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell" v-for="item in items" :key="item.ma_Code">
        <div class="weui-cell__bd">
          <p>{{item.ma_Code}}</p>
          <p class="list-item-muted">{{item.dd_prodcode}} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p class="list-item-muted">
            <span v-format="'#,##0.#'">{{item.dd_inqty}}</span>&nbsp;/&nbsp;
            <span v-format="'#,##0.#'">{{item.dd_qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <span
            class="list-item-status"
            :class="{'warning':item.md_status!='已完工'}"
          >{{item.md_getstatus}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/makeCutProgress",
      filters: [
        {
          type: "date",
          name: "make_disassemble.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL",
              condition: "1=1"
            },
            {
              value: 1,
              label: "已提交",
              mode: "DETAIL",
              condition: "md_statuscode='SUBMITTED'"
            },
            {
              value: 2,
              label: "已审核",
              mode: "DETAIL",
              condition: "md_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "已结案",
              mode: "DETAIL",
              condition: "md_statuscode='FINISH'"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.doSearch()
  }
};
</script>